/**
 * `?new=true` opens the "new" dialog of a list screen (customers, opportunities, leads): the
 * link the search of the header follows for "Novo cliente", "Nova oportunidade"…
 */
export function parseCreateSearch(search: Record<string, unknown>): { new?: true } {
  return search['new'] === true || search['new'] === 'true' ? { new: true } : {};
}

/** The same state without the "new" dialog. */
export function withoutCreate<S extends { new?: true }>(search: S): Omit<S, 'new'> {
  const { new: _new, ...rest } = search;
  return rest;
}
